import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
// import { formatMonto } from "../utils";
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";
import ColorType from "@/components/functionals/ColorType.vue";

export default [
  {
    label: "No.",
    prop: "EntryNo",
    width: 90,
    sortable: true
  },
  {
    label: "Codigo Cliente",
    prop: "CustomerNo",
    width: 150,
    sortable: true
  },
  {
    label: "Nombre Cliente",
    prop: "Customer",
    width: 400,
    sortable: true
  },
  {
    label: "Descripción",
    prop: "Description",
    width: 450,
    sortable: true
  },
  {
    label: "Monto",
    prop: "AmountInDollars",
    width: 130,
    // formatter: row => formatMonto(Number(row.Amount)),
    sortable: true
  },
  {
    label: "Agente de Cobro",
    prop: "PaymentAgentName",
    width: 250,
    sortable: true,
    formatter: ImagePersonVue,
    attrs: {
      imgKey: "ImageAccountServicePhoto"
    }
  },
  {
    label: "Fecha Emisión",
    prop: "PostingDate",
    width: 150,
    formatter: DatetimeFormatter,
    sortable: true
  },
  {
    label: "Fecha Vencimiento",
    prop: "DueDate",
    width: 170,
    formatter: DatetimeFormatter,
    sortable: true
  },
  {
    label: "Días Vencidos",
    prop: "NumberOfDaysOverDue",
    width: 150,
    sortable: true
  },
  {
    label: "Días Créditos",
    prop: "DayInvoice",
    width: 170,
    sortable: true,
    formatter: ColorType
  },
  {
    label: "Vendedor",
    prop: "SalespersonName",
    width: 250,
    sortable: true,
    formatter: ImagePersonVue,
    attrs: {
      imgKey: "ImageSalesPersonPhoto"
    }
  },
  {
    label: "Servicio al Cliente",
    prop: "CustomerServiceName",
    width: 250,
    sortable: true,
    formatter: ImagePersonVue,
    attrs: {
      imgKey: "ImageCustomerServicePhoto"
    }
  }

  // {
  //   label: "Monto 2",
  //   prop: "monto"
  // }
];
